<template>
  <page :title="i18n.title">
    <div class="wallet-out-bank-warp">
      <div class="wallet-out-bank-top">
        <span>{{i18n.price_label}}</span>
        <span class="price">{{user && user.pcurrencyName}}{{price}}</span>
      </div>
      <div class="wallet-out-bank-tips">{{i18n.wallet_out_tips}}</div>
      <div class="wallet-out-bank-form">
        <div>{{i18n.bank_account}}</div>
        <input type="number" v-model="info.bankAccount" :placeholder="i18n.bank_account_input"/>
        <div>{{i18n.contact}}</div>
        <input v-model="info.contact" :placeholder="i18n.contact_input"/>
        <div>{{i18n.bank_name}}</div>
        <input v-model="info.bankName" :placeholder="i18n.bank_name_input"/>
        <div>{{i18n.name}}</div>
        <input v-model="info.name" :placeholder="i18n.name_input"/>
      </div>
      <div class="wallet-btn">
        <button class="btn" @click="onSubmit">{{i18n.apply}}</button>
      </div>
    </div>
  </page>
</template>

<script>
import { TAJIN_APPLY } from '../../apis/user.js'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['user', 'browser']),
    i18n () {
      return this.$t('wallet_out')
    },
    deposiTips () {
      return `${this.i18n.deposit_tips}`.format(this.user)
    },
    isInfo () {
      return this.info.bankAccount && this.info.contact && this.info.bankName && this.info.name
    }
  },
  data () {
    return {
      price: 0,
      info: {
        bankAccount: '',
        contact: '',
        bankName: '',
        name: ''
      }
    }
  },
  methods: {
    onSubmit () {
      if (isNaN(this.price) || this.price <= 0) {
        this.$toast(this.i18n.msg_fail_price)
      } else if (this.price > this.user.pyajinBalance) {
        this.$toast(this.i18n.msg_fail_balance)
      } else if (!this.isInfo) {
        this.$toast(this.i18n.msg_fail_info)
      } else {
        this.$loading(true)
        this.$post(
          TAJIN_APPLY,
          {
            amount: this.price,
            remark: JSON.stringify(this.info)
          },
          resp => {
            this.$loading(false)
            this.$confirm({
              title: this.$t('msg.title'),
              content: this.i18n.msg_success_content,
              showCancel: false,
              confirmText: this.i18n.confirm
            }).then(() => {
              this.$router.go(-2)
            })
            // this.$toast(this.i18n.msg_success_content)
            this.$store.commit('user', {
              ...this.user,
              pyajinBalance: this.user.pyajinBalance - this.price
            })
            this.price = 0
            console.log(resp)
          },
          error => {
            this.$loading(false)
            this.$confirm({
              title: this.i18n.msg_title,
              content: error,
              showCancel: false,
              confirmText: this.i18n.confirm
            })
          }
        )
      }
    }
  },
  created () {
    this.price = this.$route.query.price
  }
}
</script>

<style lang="less">
.wallet-out-bank-warp {
  background-color: #fff;
  padding: 20px;
  font-size: 32px;
  .wallet-out-bank-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0 80px;
    .price {
      font-size: 46px;
      color: #409EFF;
    }
  }
  .wallet-out-bank-tips {
    font-size: 28px;
    background-color: #F8F9FA;
    padding: 20px;
    color: #00ce70;
  }
  .wallet-out-bank-form {
    div {
      padding: 40px 0 20px;
    }
    input {
      width: calc(100% - 40px);
      height: 80px;
      background-color: #F8F9FA;
      line-height: 80px;
      padding: 0 16px;
      color: #333333;
      font-size: 32px;
      border-radius: 20px;
      border: none;
    }
  }
}
</style>
